import(/* webpackMode: "eager" */ "/app/src/app/interview/drill/page.tsx");
